import * as strf from './string_utils';
import { DataType } from '../types/data_type';
import { i18n } from '../i18n/i18n';
export var utils;
(function (utils) {
    function getAllDataTypes() {
        return Object.values(DataType).filter(function (item) { return typeof item === "number"; });
    }
    utils.getAllDataTypes = getAllDataTypes;
    function getDateDataTypes() {
        return [DataType.Time, DataType.Date, DataType.DateTime];
    }
    utils.getDateDataTypes = getDateDataTypes;
    function getStringDataTypes() {
        return [DataType.String, DataType.Memo, DataType.FixedChar];
    }
    utils.getStringDataTypes = getStringDataTypes;
    var _numericTypes = [DataType.Byte, DataType.Word, DataType.Int32,
        DataType.Int64, DataType.Float, DataType.Currency, DataType.Autoinc];
    function getNumericDataTypes() {
        return _numericTypes;
    }
    utils.getNumericDataTypes = getNumericDataTypes;
    var _intTypes = [DataType.Byte, DataType.Word, DataType.Int32, DataType.Int64, DataType.Autoinc];
    //-------------- object functions -------------------
    /**
     * Copy the content of all objests passed in `args` parameters into `target`
     * and returns the result
     * NB: This function copies only the first level properties.
     * For a deep copy please use `assignDeep`
     * @param target - the target object
     * @param args  - an array of the source objects
     */
    function assign(target) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        for (var i = 0; i < args.length; i++) {
            var source = args[i];
            if (source) {
                for (var key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
        }
        return target;
    }
    utils.assign = assign;
    /**
     * Copy the content of all objests passed in `args` parameters into `target`
     * and returns the result
     * NB: This function make a deep copy -
     * so `assignDeep` will be called recursively for all object properties
     * on the first level.
     * @param target - the target object
     * @param sources  - an array of the source objects
     */
    function assignDeep(target) {
        var sources = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            sources[_i - 1] = arguments[_i];
        }
        return assignDeepCore(new WeakMap(), target, sources);
    }
    utils.assignDeep = assignDeep;
    function assignDeepCore(hashSet, target, sources) {
        if (!target) {
            target = {};
        }
        for (var _i = 0, sources_1 = sources; _i < sources_1.length; _i++) {
            var source = sources_1[_i];
            if (source) {
                for (var key in source) {
                    if (source.hasOwnProperty(key)) {
                        var sourceVal = source[key];
                        if (sourceVal !== null && typeof sourceVal === 'object') {
                            if (hashSet.has(sourceVal)) {
                                target[key] = hashSet.get(sourceVal);
                            }
                            else {
                                if (Array.isArray(sourceVal)) {
                                    target[key] = createArrayFrom(sourceVal);
                                    hashSet.set(sourceVal, target[key]);
                                }
                                else {
                                    if (typeof target[key] == 'undefined' || target[key] == null) {
                                        target[key] = Object.create(Object.getPrototypeOf(sourceVal));
                                    }
                                    hashSet.set(sourceVal, target[key]);
                                    assignDeepCore(hashSet, target[key], [sourceVal]);
                                }
                            }
                        }
                        else {
                            target[key] = sourceVal;
                        }
                    }
                }
            }
        }
        return target;
    }
    function getIfDefined(value, defaultValue) {
        return (typeof value !== 'undefined') ? value : defaultValue;
    }
    utils.getIfDefined = getIfDefined;
    function IsDefinedAndNotNull(value) {
        return typeof value !== 'undefined' && value !== null;
    }
    utils.IsDefinedAndNotNull = IsDefinedAndNotNull;
    function copyArrayTo(collection1, collection2) {
        var len1 = collection1.length;
        var len2 = collection2.length;
        for (var i = 0; i < len1 && i < len2; i++) {
            collection2[i] = collection1[i];
        }
    }
    utils.copyArrayTo = copyArrayTo;
    function createArrayFrom(collection) {
        var result = [];
        for (var _i = 0, collection_1 = collection; _i < collection_1.length; _i++) {
            var item = collection_1[_i];
            result.push(item);
        }
        return result;
    }
    utils.createArrayFrom = createArrayFrom;
    /**
     * Searches an array of the objects which implement ItemWithId by ID
     * Returs the found object or null.
     * @param array
     * @param id
     */
    function findItemById(array, id) {
        var arrLength = array.length;
        for (var idx = 0; idx < arrLength; idx++) {
            if (array[idx].id === id)
                return array[idx];
        }
        return null;
    }
    utils.findItemById = findItemById;
    function findItemIndexById(array, id) {
        var arrLength = array.length;
        for (var idx = 0; idx < arrLength; idx++) {
            if (array[idx].id === id)
                return idx;
        }
        return -1;
    }
    utils.findItemIndexById = findItemIndexById;
    /**
     * Searches an array of the objects which implement ItemWithId by ID
     * Returs the index of the found element, or -1 if nothing was found.
     * @param array
     * @param id
     */
    function indexOfArrayItem(arr, item) {
        if (arr.indexOf) {
            return arr.indexOf(item);
        }
        else {
            var len = arr.length;
            for (var i = 0; i < len; i++) {
                if (item == arr[i]) {
                    return i;
                }
            }
            return -1;
        }
    }
    utils.indexOfArrayItem = indexOfArrayItem;
    /**
     * Moves an item in some array to a new position
     * @param array
     * @param index1
     * @param index2
     */
    function moveArrayItem(array, index1, index2) {
        if (index1 >= array.length) {
            throw 'Index out of bounds: ' + index1;
        }
        if (index2 >= array.length) {
            index2 = array.length - 1;
        }
        var item = array.splice(index1, 1)[0];
        array.splice(index2, 0, item);
    }
    utils.moveArrayItem = moveArrayItem;
    /**
     * Searches for a particular item in the array are removes that item if found.
     * @param arr
     * @param value
     */
    function removeArrayItem(arr, value) {
        var index = arr.indexOf(value);
        if (index != -1) {
            return arr.splice(index, 1)[0];
        }
    }
    utils.removeArrayItem = removeArrayItem;
    function insertArrayItem(arr, index, value) {
        arr.splice(index, 0, value);
    }
    utils.insertArrayItem = insertArrayItem;
    function fillArray(arr, value, start, end) {
        if (start === void 0) { start = 0; }
        var len = arr.length >>> 0;
        var relativeStart = start >> 0;
        var k = relativeStart < 0 ?
            Math.max(len + relativeStart, 0) :
            Math.min(relativeStart, len);
        var relativeEnd = end === undefined ?
            len : end >> 0;
        var final = relativeEnd < 0 ?
            Math.max(len + relativeEnd, 0) :
            Math.min(relativeEnd, len);
        while (k < final) {
            arr[k] = value;
            k++;
        }
        return arr;
    }
    utils.fillArray = fillArray;
    //------------ DOM utils ------------
    /**
     * Calculates the shift on which we need to move our element horizontally
     * to find current window
     * @param absLeft
     * @param width
     */
    function shiftToFitWindow(absLeft, width) {
        var body = document.getElementsByTagName('body')[0];
        var winWidth = window.innerWidth || document.documentElement.clientWidth || body.clientWidth;
        var absRight = absLeft + width;
        var shift = 0;
        if (absRight > winWidth) {
            shift = winWidth - absRight - 10;
            if (absLeft + shift < 0) {
                shift = 10 - absLeft;
            }
        }
        return shift;
    }
    utils.shiftToFitWindow = shiftToFitWindow;
    /**
     * Returns `true` if the value passed in the parameter is an object
     * @param val
     */
    function isObject(val) {
        if (val === null) {
            return false;
        }
        return ((typeof val === 'function') || (typeof val === 'object'));
    }
    utils.isObject = isObject;
    /**
     * Returns `true` if the `DataType` value passed in the parameter
     * represents some numeric type
     * @param dtype
     */
    function isNumericType(dtype) {
        var index = _numericTypes.indexOf(dtype);
        return (index >= 0);
    }
    utils.isNumericType = isNumericType;
    /**
     * Returns `true` if the `DataType` value passed in the parameter
     * represents some numeric type
     * @param dtype
     */
    function isIntType(dtype) {
        var index = _intTypes.indexOf(dtype);
        return (index >= 0);
    }
    utils.isIntType = isIntType;
    /**
     * Returns `true` if the value passed in the parameter is an a numeric value
     * @param val
     */
    function isNumeric(val) {
        return !isNaN(parseFloat(val)) && isFinite(val);
    }
    utils.isNumeric = isNumeric;
    /**
     * Returns `true` if two data types  passed in parameters
     * are compatible - so it's safe to copy the values between
     * two expressions with these two types
     * @param type1
     * @param type2
     */
    function areCompatibleDataTypes(type1, type2) {
        return typeof type1 == "undefined" || typeof type2 == "undefined" || type1 == DataType.Unknown || type2 == DataType.Unknown
            || (type1 == type2) || (type1 == DataType.Date && type2 == DataType.DateTime)
            || (type1 == DataType.DateTime && type2 == DataType.Date);
    }
    utils.areCompatibleDataTypes = areCompatibleDataTypes;
    /**
     * Returns `true` if the property with named `propName`
     * in the object `obj` has some value
     * @param obj
     * @param propName
     */
    function isPropSet(obj, propName) {
        return obj[propName] || obj[propName.toLowerCase()] || obj[propName.toUpperCase()];
    }
    utils.isPropSet = isPropSet;
    //-------------- ID generator -----------
    var prefixIdLen = 4;
    var symbols = "0123456789abcdefghijklmnopqrstuvwxyz";
    var magicTicks = 636712160627685350;
    /**
     * Generates an unique ID
     */
    function generateId(prefix) {
        if (!prefix) {
            prefix = 'easy';
        }
        var prfx = (prefix.length > prefixIdLen) ? squeezeMoniker(prefix, prefixIdLen) : prefix;
        if (prfx && prfx.length > 0) {
            prfx += "-";
        }
        //adding 2 random symbols
        var randValue = strf.repeatString("", 2);
        ;
        var maxSymbolIndex = symbols.length - 1;
        randValue = replaceAtString(randValue, 0, symbols[getRandomInt(0, maxSymbolIndex)]);
        randValue = replaceAtString(randValue, 1, symbols[getRandomInt(0, maxSymbolIndex)]);
        //generating main ID part (64-base representation of the current value of the time ticks)
        var ticksNum64 = intToNum36(getNowTicks() - magicTicks);
        return prfx + randValue + ticksNum64;
    }
    utils.generateId = generateId;
    function intToNum36(value) {
        var targetBase = 36;
        var i = 14;
        var buffer = strf.repeatString("", i);
        var rest = value;
        do {
            buffer = replaceAtString(buffer, i--, symbols[rest % targetBase]);
            rest = Math.floor(rest /= targetBase);
        } while (rest > 0);
        return strf.reverseString(buffer.trim());
    }
    function squeezeMoniker(str, maxlen) {
        var parts = str.split('-');
        var pml = 1;
        var ptt = maxlen;
        if (parts.length < maxlen) {
            pml = maxlen / parts.length;
            ptt = parts.length;
        }
        var result = "";
        for (var i = 0; i < ptt; i++) {
            result += squeeze(parts[i], pml);
        }
        return result;
    }
    function squeeze(str, maxlen) {
        var len = str.length;
        if (len > maxlen) {
            var step = len / maxlen;
            var result = "";
            result += str[0];
            var nextIndex = step;
            var ch = void 0;
            for (var i = 1; i < len; i++) {
                ch = str[i];
                if (i + 1 > nextIndex) {
                    result += ch;
                    nextIndex += step;
                }
            }
            return result;
        }
        else {
            return str;
        }
    }
    function replaceAtString(str, index, value) {
        return str.substr(0, index) + value + str.substr(index + value.length);
    }
    function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }
    function getNowTicks() {
        return (621355968e9 + (new Date()).getTime() * 1e4);
    }
    function safeParseInt(str) {
        var res = parseInt(str);
        if (isNaN(res))
            throw "\"" + str + "\" is not a valid number";
        return res;
    }
    function getDaysInMonth(month, year) {
        return new Date(year, month + 1, 0).getDate();
    }
    // ------------- date/time functions -------------------
    // TO DO: improve to process all datetime cases
    function strToDateTime(value, format) {
        if (!value || value.length == 0)
            return new Date();
        var normalizedValue = value.replace(/[^a-zA-Z0-9_]/g, '-');
        var normalizedFormat = format.replace(/[^a-zA-Z0-9_]/g, '-');
        var formatItems = normalizedFormat.split('-');
        var dateItems = normalizedValue.split('-');
        var monthIndex = formatItems.indexOf("MM");
        var dayIndex = formatItems.indexOf("dd");
        var yearIndex = formatItems.indexOf("yyyy");
        var hourIndex = formatItems.indexOf("HH");
        var minutesIndex = formatItems.indexOf("mm");
        var secondsIndex = formatItems.indexOf("ss");
        var today = new Date();
        try {
            var year = yearIndex > -1 && yearIndex < dateItems.length
                ? safeParseInt(dateItems[yearIndex])
                : today.getFullYear();
            var month = monthIndex > -1 && monthIndex < dateItems.length
                ? safeParseInt(dateItems[monthIndex]) - 1
                : today.getMonth() - 1;
            if (month > 11)
                throw '';
            var day = dayIndex > -1 && dayIndex < dateItems.length
                ? safeParseInt(dateItems[dayIndex])
                : today.getDate();
            if (day > getDaysInMonth(month, year))
                throw '';
            var hour = hourIndex > -1 && hourIndex < dateItems.length
                ? safeParseInt(dateItems[hourIndex])
                : 0;
            if (hour > 23)
                throw '';
            var minute = minutesIndex > -1 && minutesIndex < dateItems.length
                ? safeParseInt(dateItems[minutesIndex])
                : 0;
            if (minute > 59)
                throw '';
            var second = secondsIndex > -1 && secondsIndex < dateItems.length
                ? safeParseInt(dateItems[secondsIndex])
                : 0;
            if (second > 59)
                throw '';
            return new Date(year, month, day, hour, minute, second);
        }
        catch (_a) {
            throw value + " is not a valid date.";
        }
    }
    utils.strToDateTime = strToDateTime;
    function strToTime(str) {
        var timeItems = str.split(':');
        try {
            var hour = timeItems.length > 0 ? safeParseInt(timeItems[0]) : 0;
            if (hour > 23)
                throw '';
            var minute = timeItems.length > 1 ? safeParseInt(timeItems[1]) : 0;
            if (minute > 59)
                throw '';
            var second = timeItems.length > 1 ? safeParseInt(timeItems[1]) : 0;
            if (second > 59)
                throw '';
            return new Date(0, 0, 0, hour, minute, second);
        }
        catch (_a) {
            throw str + " is not a valid time.";
        }
    }
    utils.strToTime = strToTime;
    var DT_FORMAT_RGEX = /\[([^\]]+)]|y{2,4}|M{1,4}|d{1,2}|H{1,2}|h{1,2}|m{2}|s{2}|t{2}/g;
    /**
     * Returns string representation of the date/time value according to the custom format (second parameter)
     * The format is compatible with the one used in .NET: https://docs.microsoft.com/en-us/dotnet/standard/base-types/custom-date-and-time-format-strings
     * @param date
     * @param format
     */
    function dateTimeToStr(date, format) {
        var year = date.getFullYear();
        var yearStr = year.toString();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        var hour12 = hour % 12 || 12; //the remainder of the division by 12. Or 12 if it's 0
        var isPm = hour > 11;
        var matches = {
            yyyy: yearStr,
            yy: yearStr.substring(yearStr.length - 2),
            MMMM: i18n.getLongMonthName(month),
            MMM: i18n.getShortMonthName(month),
            MM: (month < 10) ? '0' + month : month.toString(),
            M: month.toString(),
            dd: (day < 10) ? '0' + day : day.toString(),
            d: day.toString(),
            HH: (hour < 10) ? '0' + hour : hour.toString(),
            H: hour.toString(),
            hh: (hour12 < 10) ? '0' + hour12 : hour12.toString(),
            h: hour12.toString(),
            tt: isPm ? 'PM' : 'AM',
            mm: (minute < 10) ? '0' + minute : minute.toString(),
            ss: (second < 10) ? '0' + second : second.toString()
        };
        return format.replace(DT_FORMAT_RGEX, function (match, $1) {
            return $1 || matches[match];
        });
    }
    utils.dateTimeToStr = dateTimeToStr;
    /**
    * Converts a numeric value to the string taking into the account the decimal separator
    * @param value - the number to convert
    * @param decimalSeparator - the symbol that represents decimal separator. If not specified the function gets the one from the current locale settings.
    */
    function numberToStr(number, decimalSeparator) {
        decimalSeparator = decimalSeparator || i18n.getLocaleSettings().decimalSeparator;
        return number.toString().replace('.', decimalSeparator);
    }
    utils.numberToStr = numberToStr;
})(utils || (utils = {}));
//# sourceMappingURL=utils.js.map